import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Locations\CityController::index
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/dashboard/locations/cities'
*/
export const index = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/cities',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::index
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/dashboard/locations/cities'
*/
index.url = (options?: RouteQueryOptions) => {
    return index.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::index
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/dashboard/locations/cities'
*/
index.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::index
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/dashboard/locations/cities'
*/
index.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::index
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/dashboard/locations/cities'
*/
const indexForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::index
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/dashboard/locations/cities'
*/
indexForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::index
* @see app/Http/Controllers/Admin/Locations/CityController.php:16
* @route '/dashboard/locations/cities'
*/
indexForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::create
* @see app/Http/Controllers/Admin/Locations/CityController.php:33
* @route '/dashboard/locations/cities/create'
*/
export const create = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

create.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/cities/create',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::create
* @see app/Http/Controllers/Admin/Locations/CityController.php:33
* @route '/dashboard/locations/cities/create'
*/
create.url = (options?: RouteQueryOptions) => {
    return create.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::create
* @see app/Http/Controllers/Admin/Locations/CityController.php:33
* @route '/dashboard/locations/cities/create'
*/
create.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::create
* @see app/Http/Controllers/Admin/Locations/CityController.php:33
* @route '/dashboard/locations/cities/create'
*/
create.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: create.url(options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::create
* @see app/Http/Controllers/Admin/Locations/CityController.php:33
* @route '/dashboard/locations/cities/create'
*/
const createForm = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::create
* @see app/Http/Controllers/Admin/Locations/CityController.php:33
* @route '/dashboard/locations/cities/create'
*/
createForm.get = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::create
* @see app/Http/Controllers/Admin/Locations/CityController.php:33
* @route '/dashboard/locations/cities/create'
*/
createForm.head = (options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: create.url({
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

create.form = createForm

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::store
* @see app/Http/Controllers/Admin/Locations/CityController.php:48
* @route '/dashboard/locations/cities'
*/
export const store = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/dashboard/locations/cities',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::store
* @see app/Http/Controllers/Admin/Locations/CityController.php:48
* @route '/dashboard/locations/cities'
*/
store.url = (options?: RouteQueryOptions) => {
    return store.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::store
* @see app/Http/Controllers/Admin/Locations/CityController.php:48
* @route '/dashboard/locations/cities'
*/
store.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::store
* @see app/Http/Controllers/Admin/Locations/CityController.php:48
* @route '/dashboard/locations/cities'
*/
const storeForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::store
* @see app/Http/Controllers/Admin/Locations/CityController.php:48
* @route '/dashboard/locations/cities'
*/
storeForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::edit
* @see app/Http/Controllers/Admin/Locations/CityController.php:69
* @route '/dashboard/locations/cities/{city}/edit'
*/
export const edit = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

edit.definition = {
    methods: ["get","head"],
    url: '/dashboard/locations/cities/{city}/edit',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::edit
* @see app/Http/Controllers/Admin/Locations/CityController.php:69
* @route '/dashboard/locations/cities/{city}/edit'
*/
edit.url = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return edit.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::edit
* @see app/Http/Controllers/Admin/Locations/CityController.php:69
* @route '/dashboard/locations/cities/{city}/edit'
*/
edit.get = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::edit
* @see app/Http/Controllers/Admin/Locations/CityController.php:69
* @route '/dashboard/locations/cities/{city}/edit'
*/
edit.head = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: edit.url(args, options),
    method: 'head',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::edit
* @see app/Http/Controllers/Admin/Locations/CityController.php:69
* @route '/dashboard/locations/cities/{city}/edit'
*/
const editForm = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::edit
* @see app/Http/Controllers/Admin/Locations/CityController.php:69
* @route '/dashboard/locations/cities/{city}/edit'
*/
editForm.get = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::edit
* @see app/Http/Controllers/Admin/Locations/CityController.php:69
* @route '/dashboard/locations/cities/{city}/edit'
*/
editForm.head = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: edit.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

edit.form = editForm

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::update
* @see app/Http/Controllers/Admin/Locations/CityController.php:80
* @route '/dashboard/locations/cities/{city}'
*/
export const update = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: '/dashboard/locations/cities/{city}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::update
* @see app/Http/Controllers/Admin/Locations/CityController.php:80
* @route '/dashboard/locations/cities/{city}'
*/
update.url = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return update.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::update
* @see app/Http/Controllers/Admin/Locations/CityController.php:80
* @route '/dashboard/locations/cities/{city}'
*/
update.put = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::update
* @see app/Http/Controllers/Admin/Locations/CityController.php:80
* @route '/dashboard/locations/cities/{city}'
*/
const updateForm = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::update
* @see app/Http/Controllers/Admin/Locations/CityController.php:80
* @route '/dashboard/locations/cities/{city}'
*/
updateForm.put = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::destroy
* @see app/Http/Controllers/Admin/Locations/CityController.php:101
* @route '/dashboard/locations/cities/{city}'
*/
export const destroy = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/dashboard/locations/cities/{city}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::destroy
* @see app/Http/Controllers/Admin/Locations/CityController.php:101
* @route '/dashboard/locations/cities/{city}'
*/
destroy.url = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { city: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { city: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            city: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        city: typeof args.city === 'object'
        ? args.city.id
        : args.city,
    }

    return destroy.definition.url
            .replace('{city}', parsedArgs.city.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::destroy
* @see app/Http/Controllers/Admin/Locations/CityController.php:101
* @route '/dashboard/locations/cities/{city}'
*/
destroy.delete = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::destroy
* @see app/Http/Controllers/Admin/Locations/CityController.php:101
* @route '/dashboard/locations/cities/{city}'
*/
const destroyForm = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Locations\CityController::destroy
* @see app/Http/Controllers/Admin/Locations/CityController.php:101
* @route '/dashboard/locations/cities/{city}'
*/
destroyForm.delete = (args: { city: string | number | { id: string | number } } | [city: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: destroy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'DELETE',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

destroy.form = destroyForm

const cities = {
    index: Object.assign(index, index),
    create: Object.assign(create, create),
    store: Object.assign(store, store),
    edit: Object.assign(edit, edit),
    update: Object.assign(update, update),
    destroy: Object.assign(destroy, destroy),
}

export default cities